import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import OpenBankingExplainer from '@/components/ModalRenderer/components/components/OpenBankingExplainer';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

type Props = ModalProps<{
  onContinueWithOpenBanking: () => void;
}>;

const OpenBankingRecoveryInfo = ({ closeModal, payload: { onContinueWithOpenBanking } }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('OpenBankingRecoveryInfo.title')}>
      <OpenBankingExplainer />
      <ModalActions>
        <Button
          onClick={() => {
            onContinueWithOpenBanking();
            closeModal();
          }}
        >
          {t('OpenBankingRecoveryInfo.button')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default OpenBankingRecoveryInfo;
